import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-grow-1 h-100" }
const _hoisted_2 = {
  key: 1,
  class: "d-flex flex-column align-items-center justify-content-center flex-grow-1 text-center px-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-size-md mb-2" }, "Provide your location to view Map.", -1 /* HOISTED */)
const _hoisted_4 = {
  key: 2,
  class: "flex-grow-1",
  id: "Patient__VisitMap"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex w-100 justify-content-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }),
  /*#__PURE__*/_createElementVNode("b", { class: "mx-2" }, "Waiting for your location"),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" })
], -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FindNearbyEmployees = _resolveComponent("FindNearbyEmployees")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showNearbyEmpPanel)
      ? (_openBlock(), _createBlock(_component_FindNearbyEmployees, {
          key: 0,
          showNearbyEmpPanel: _ctx.showNearbyEmpPanel,
          "onUpdate:showNearbyEmpPanel": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showNearbyEmpPanel) = $event)),
          selectedPatientVisit: _ctx.selectedVisitDetails,
          patientInfoWindowContent: _ctx.patientInfoWindow,
          date: _ctx.date
        }, null, 8 /* PROPS */, ["showNearbyEmpPanel", "selectedPatientVisit", "patientInfoWindowContent", "date"]))
      : (_ctx.zipNotEntered)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("button", {
              class: "btn btn-xs btn-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.enterLocation()))
            }, "ENTER LOCATION")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
  ]))
}